<template>
  <div class="issueCenter">
    <div v-if="!$isFlag" class="left">
      <p
        v-for="(item, index) in leftList"
        :key="index"
        :class="index === currentIndex ? 'active' : ''"
        @click="titleClick(index,item.url)"
      >
        <img :src="getImg(item,index)" alt="">
        <span>{{ item.name }}</span>
      </p>
    </div>
    <div class="right">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Index',
  components: {

  },
  data() {
    return {
      username: '',
      checked: false,
      currentIndex: 0,
      ltCaptcha: null,
      isShow: true,
      leftList: [
        { name: '账号信息', icon: 'zhanghao@2x(1)', icon_active: 'zhanghao@2x', url: '/accountCenter/accountList/accountInfo' },
        { name: '修改密码', icon: 'mima@2x(1)', icon_active: 'mima@2x', url: '/accountCenter/accountList/editPhoneNum?type=PWD_MODIFY' },
        { name: '身份认证', icon: 'shenfen@2x(1)', icon_active: 'shenfen@2x', url: '/accountCenter/accountList/identityAuth' },
        { name: '手机号管理', icon: 'shouji@2x(1)', icon_active: 'shouji@2x', url: '/accountCenter/accountList/phoneManage' },
        // { name: '手机号管理', icon: 'shouji@2x(1)', icon_active: 'shouji@2x', url: '/accountCenter/accountList/phoneAuth' },
        { name: '账号/单手游注销', icon: 'zhuxiao@2x(1)', icon_active: 'zhuxiao@2x', url: '/accountCenter/accountList/logoutAccount' },
        { name: '账号安全', icon: 'security@2x(1)', icon_active: 'security@2x', url: '/accountCenter/accountList/accountSecurity' }
      ]
    }
  },
  computed: {},
  watch: {
    $route: {
      handler: function(val, oldVal) {
        console.log(val, 'aacccccccccccccccccccccccccccccccc')
        this.getCurrentIndex(val.name)
      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
  },
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.issueCenter').className = ['issueCenter issueCenterH5 accountCommonH5']
    } else {
      document.querySelector('.issueCenter').className = ['issueCenter issueCenterWeb accountCommonWeb']
    }
    this.getCurrentIndex(this.$route.name)
  },
  methods: {
    getCurrentIndex(name) {
      switch (name) {
        case 'accountInfo':
          this.currentIndex = 0
          this.$ssd.track('leiting_accountmanage_clickAccountInfo')
          break
        case 'editPhoneNum':
          this.$ssd.track('leiting_accountmanage_clickEditPassword')
          this.currentIndex = 1
          break
        case 'identityAuth':
          this.$ssd.track('leiting_accountmanage_clickidentityAuth')
          this.currentIndex = 2
          break
        case 'phoneAuth':
          this.$ssd.track('leiting_accountmanage_clickPhone')
          this.currentIndex = 3
          break
        case 'phoneManage':
          this.$ssd.track('leiting_accountmanage_clickPhoneManage')
          this.currentIndex = 3
          break
        case 'faceRecognitionAuth':
          this.$ssd.track('leiting_accountmanage_faceRecognitionAuth')
          this.currentIndex = 3
          break
        case 'logoutAccount':
          this.$ssd.track('leiting_accountmanage_clickAccountOut')
          this.currentIndex = 4
          break
        case 'accountSecurity':
          this.$ssd.track('leiting_accountmanage_accountSecurity')
          this.currentIndex = 5
          break
        default:
          break
      }
    },
    getImg(item, index) {
      if (index == this.currentIndex) {
        return require('@/assets/images/accountCenter/' + item.icon_active + '.png')
      }
      return require('@/assets/images/accountCenter/' + item.icon + '.png')
    },
    typeClick(index) {},
    onSubmit() {},
    titleClick(index, url) {
      this.currentIndex = index
      console.log(this.$route.fullPath, url)
      if (this.$route.fullPath != url) {
        this.$router.push(url)
      } else {
        location.reload()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
// h5
  .issueCenterH5 {
    font-size: 0.25rem;
    z-index 999
    .checkbox {
      margin: 0.5rem;
    }
    #ltCaptchaLogin {
      display: flex;
      justify-content: center;
    }
    .captcha {
      margin: 0.2rem;
    }
    .captcha .sm-btn-wrapper .sm-btn {
      width: 100% !important;
    }
    .right {
      border-radius: 10px;
      background: #fff;
      z-index 999
    }
  }
// web
  .issueCenterWeb {
    font-size: 0.25rem;
    display: flex;
    margin: 5%;
    min-height: 10rem;
    .left {
      flex: 2;
      padding: 0.5rem 0;
      background: #fff;
      font-size: 0.36rem;
      border-radius: 10px;
      p {
        padding: 0.2rem 0 0.2rem 0.5rem;
        color: #5D5D5D;
        display: flex;
        align-items: center;
        height: .8rem;
        cursor pointer
        transition: 0.2s ease-out
        img{
          height: .44rem;
          margin-right: .2rem;
        }
      }
      p:hover {
        opacity 0.7
      }
      .active {
        background: #eff1ff;
        color: #616edf;
      }
    }
    .right {
      flex: 7;
      border-radius: 10px;
      background: #fff;
      margin-left: 0.2rem;
    }
  }
</style>
